import flStyle from "./FoodsSumm.module.css";

const FoodsSumm = () => {
  return (
    <section className={flStyle.summary}>
      <h2>Delicious Food Untuk Perutmu</h2>
      <p>Pilih makanan untuk perutmu</p>
      <p>Kualitas dan Kebersihan adalah Koentjienya</p>
    </section>
  );
};

export default FoodsSumm;
